<template>
  <div class="ONE-TIME-CODE">
    <div class="text-left">
      <router-link
          :to="{
            name: 'one-time-code',
            query: {
              redirectTo,
            },
          }"
          class="link-black">
        <vk-icon name="chevronleft" class="c-depot"/>Back
      </router-link>
    </div>
    <one-time-code-sign-in-form/>
    Already have an account?
    <router-link
        :to="{
          name: 'login',
          query: {
            redirectTo,
          }
        }"
        class="link">
      Sign in with password.
    </router-link>
  </div>
</template>

<script>
import OneTimeCodeSignInForm from '@/components/OneTimeCodeSignInForm';

export default {
  name: 'one-time-code-sign-in',
  components: {
    OneTimeCodeSignInForm,
  },
  data () {
    return {
      redirectTo: this.$route.params.redirectTo,
    };
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .ONE-TIME-CODE {
    text-align: center;
    @include margin(6 auto);
  }
</style>
